<template>
  <div :style="{ background: event.branding.tertiaryColor }">
    <div class="button-bar">
      <BasicButtons
        :is-translator="false"
        :supports-screen-share="true"
        :local-mute="micPaused"
        :local-video-mute="vidPaused"
        :hand-raised="handRaised"
        :client-role="clientRole"
        :req-to-speak-mode="reqToSpeakMode"
        :req-to-speak-ongoing="reqToSpeakOngoing"
        :allowed-to-speak="allowedToSpeak"
        @leave="$emit('leave')"
        @toggle-mute="$emit('toggle-mute')"
        @toggle-video-mute="$emit('toggle-video-mute')"
        @toggle-screen="$emit('toggle-screen')"
        @toggle-raiseHand="$emit('toggle-raiseHand')"
        @request-switch-to-host="$emit('request-switch-to-host')"
        @switch-to-host="$emit('switch-to-host')"
      />
    </div>
  </div>
</template>
<script>
/**
 * Controls for the Viewer
 * @displayName Viewer Overlay
 */
import { mapState } from "vuex";
import BasicButtons from "./BasicButtons.vue";

export default {
  name: "ViewerOverlay",
  components: {
    BasicButtons,
  },
  props: {
    event: Object,
  },
  data() {
    return {
      clientRole: "audience",
    };
  },
  computed: {
    ...mapState({
      micPaused: (state) => state.mediasoup.micPaused,
      vidPaused: (state) => state.mediasoup.vidPaused,
      handRaised: (state) => state.mediasoup.handRaised,
      reqToSpeakMode: (state) => state.mediasoup.reqToSpeakMode,
      reqToSpeakOngoing: (state) => state.mediasoup.reqToSpeakOngoing,
      allowedToSpeak: (state) => state.mediasoup.allowedToSpeak,
    }),
  },
};
</script>
